module.exports = __webpack_public_path__ + "static/media/google-plus-logo-charcoal.0075826c.svg";